import { PaginationItemProps, SxProps } from '@mui/material';
import { TextV2 } from '@insights-ltd/design-library/components';
import { Theme } from '@mui/material/styles';

/**
 * This component returns slots to be passed to MuiPaginationItem
 */
export const CustomNavigationLabels = (
  labels: { prev: string; next: string },
  sx?: SxProps<Theme>,
): PaginationItemProps['slots'] => {
  const Previous = () => <TextV2 sx={sx}>{labels.prev}</TextV2>;
  const Next = () => <TextV2 sx={sx}>{labels.next}</TextV2>;

  return { previous: Previous, next: Next };
};

export default CustomNavigationLabels;
